import { Controller } from '@hotwired/stimulus';

import Zipcoder from '@/modules/zipcoder';

export default class extends Controller {
  connect() {
    new Zipcoder({ scope: 'payment' }).create();
  }
}
